import React from 'react';

import { useTranslation } from 'react-i18next';
import { useMatches } from 'react-router-dom';

import { CardIcon } from 'assets/images';
import BottomNavbar from 'components/UI/BottomNavBar';
import CustomModal from 'components/UI/CustomModal';
import MainContent from 'components/UI/MainContent/MainContent';
import Topbar from 'components/UI/TopBar/Topbar';
import useCustomModal from 'hooks/useCustomModal';

const MainLayout = () => {
  const { t } = useTranslation();
  const { isModal, toggleModal, handleToggleModal } = useCustomModal();
  const matches = useMatches();
  const titleKey = [...matches].reverse().find((match) => match.handle?.title)?.handle?.title;

  return (
    <>
      {/* use this custom modal to display messages */}
      <CustomModal onClose={toggleModal} show={isModal?.open} subTitle={isModal?.message2} title={isModal?.message} />
      <Topbar pageName={titleKey ? t(titleKey) : undefined} />
      <MainContent bgImage={CardIcon} toggleModal={handleToggleModal} />
      <BottomNavbar />
    </>
  );
};

export default MainLayout;
